import React, { useState, useEffect } from "react";
import { makeStyles, withStyles, useTheme } from "@material-ui/core/styles";
import { useHistory } from "react-router-dom";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import TablePagination from "@material-ui/core/TablePagination";
import { REACT_APP_PROD_URL } from "../../services/configs";

import * as Sentry from "@sentry/react";
import { useSelector } from "react-redux";
import fetcher from "../../api/swr_fetcher";

export default function ActivityLogs() {
  const classes = useStyles();
  const theme = useTheme();
  let history = useHistory();

  const [logs, setLogs] = useState(null);

  // for pagination
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const token = useSelector((state) => state.trading.TOKEN);

  useEffect(() => {
    if (token) {
      fetcher(`/v1/um/iplog`)
        .then((data) => {
          if (!data.status) {
            data.sort(function (a, b) {
              return a.loginTime > b.loginTime
                ? -1
                : a.loginTime < b.loginTime
                ? 1
                : 0;
            });
            setLogs(data);
          }
          // console.log(data);
        })
        .catch((err) => {
          console.error(err);
          // console.error(err);
        });

      // console.log("Getting the activity logs");
    }
  }, []);

  return (
    <div className={classes.root}>
      <p className={classes.topHeading}>Activity Logs</p>

      <div className={classes.paddedContainer}>
        <TableContainer style={{ maxHeight: "800px" }}>
          <Table
            className={classes.table}
            stickyHeader
            aria-label="sticky table"
          >
            <TableHead>
              <TableRow>
                <TableCell>Login Time</TableCell>
                <TableCell align="left">User Agent</TableCell>
                <TableCell align="left">IP Address</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {logs
                ? logs
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row) => (
                      <TableRow key={row.loginTime}>
                        <TableCell component="th" scope="row">
                          {row.loginTime.slice(8, 10)}.
                          {row.loginTime.slice(5, 7)}.
                          {row.loginTime.slice(0, 4)}{" "}
                          {row.loginTime.slice(11, 16)}
                        </TableCell>
                        <TableCell align="left">{row.userAgent}</TableCell>
                        <TableCell align="left">{row.ipAddress}</TableCell>
                      </TableRow>
                    ))
                : null}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[10, 25, 100]}
          component="div"
          count={logs ? logs.length : 10}
          rowsPerPage={rowsPerPage}
          page={page}
          onChangePage={handleChangePage}
          onChangeRowsPerPage={handleChangeRowsPerPage}
        />
      </div>
    </div>
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    // marginTop: theme.spacing(10),
    // marginLeft: theme.spacing(10),
    // alignItems: "center",
    [theme.breakpoints.down("sm")]: {
      // width: '90%',
      marginTop: "20px",
      maxWidth: "450px",
      // minWidth: "450px",
      // marginLeft: "25px",
      // marginRight: "25px",
    },
    [theme.breakpoints.up("md")]: {
      // width: "50%",
      marginTop: "50px",
    },
    // margin: "auto",
    marginBottom: "80px",
  },
  paddedContainer: {
    padding: "40px",
    background: theme.palette.type === "dark" ? "#151827" : "white",
  },
  topHeading: {
    color: "#3AC4AB",
    fontWeight: "bold",
    [theme.breakpoints.down("xs")]: {
      fontSize: "1.3rem",
    },
    [theme.breakpoints.up("sm")]: {
      fontSize: "2rem",
    },
  },
}));
